import { setHistoryTool } from "@/api";
import { IS_PROD } from ".";

/**
 * 记录用户最近使用的功能
 * 触发时机是打开图片
 */
export const putHistoryToolUse = () => {
  const testToolId = "4de8bb16e23641219c51047757713de7"; //测试环境工具ID, 文档未补充
  const prodToolId = "62d471ee04d847d689280437275b6813"; //正式环境工具ID
  const toolId = IS_PROD ? prodToolId : testToolId;
  if (!toolId) {
    console.warn(`tool id not found`);
    return;
  }
  setHistoryTool(toolId);
};
